import React from 'react';
import { Marker } from 'react-leaflet';

function isValidLeafletPosition(position) {
  return (
    Array.isArray(position) &&
    position.length === 2 &&
    Number.isFinite(position[0]) &&
    Number.isFinite(position[1])
  );
}

const ZoomIndependentMarker = React.forwardRef(({
  position,
  icon,
  children,
  eventHandlers,
  ...props
}, ref) => {
  if (!isValidLeafletPosition(position)) {
    return null;
  }
  return (
    <Marker
      ref={ref}
      position={position}
      icon={icon}
      eventHandlers={eventHandlers}
      {...props}
    >
      {children}
    </Marker>
  );
});

ZoomIndependentMarker.displayName = 'ZoomIndependentMarker';

export default ZoomIndependentMarker;
